import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { FileUploadCreateRequest, FileUploadFinalizeRequest, FileUploadAbortRequest } from '../../requests/platform/file-upload-create.request';
import { FileUploadCreateResponse, FileUploadFinalizeResponse, FileUploadAbortResponse } from '../../responses/platform/file-upload-create.response';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService extends CommonService {
  private readonly base = environment.urlApiPlatform + 'FileUpload/';

  constructor(private http: HttpClient) {
    super();
  }

  create(req: FileUploadCreateRequest): Observable<FileUploadCreateResponse> {
    const url = this.base + 'Create';
    return this.http
      .post<FileUploadCreateResponse>(url, req, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  finalize(req: FileUploadFinalizeRequest): Observable<FileUploadFinalizeResponse> {
    const url = this.base + 'Finalize';
    return this.http
      .post<FileUploadFinalizeResponse>(url, req, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  abort(req: FileUploadAbortRequest): Observable<FileUploadAbortResponse> {
    const url = this.base + 'Abort';
    return this.http
      .post<FileUploadAbortResponse>(url, req, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * PUT direto no GCS (signed URL)
   * - NÃO usa addHeaderToken()
   * - NÃO força CORS headers (quem manda isso é o bucket)
   */
  uploadToSignedUrl(uploadUrl: string, file: File, contentType: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': contentType || file.type || 'application/octet-stream',
    });

    // GCS signed PUT normalmente responde 200/201 sem body
    return this.http.put(uploadUrl, file, {
      headers,
      responseType: 'text' as any
    });
  }
}
